<template>
  <div v-if="quotes && quotes.length > 0" class="quotes">
    <div v-for="(q, i) in quotes" :key="i" class="quote">
      <div class="details">
        {{ q.description }}
      </div>
      <div class="amt">
        <span>{{ isHidePrices ? "NA" : quote(q) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({ quotes: Array, isHidePrices: Boolean });

const quote = q => {
  return (
    q.cost_currency +
    " " +
    q.cost.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};
</script>

<style lang="less">
#itineraries {
  .quotes {
    border-top: 0.0625rem solid @light;
    padding: 2rem;

    .quote {
      align-items: flex-start;
      display: flex;
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .details {
      flex: 1;
    }
  }
}
</style>
